import {
    TAG_CLOUD,
    PROJECT_LISTING,
    UPDATE_TAG_ID,
    PROJECT_LISTING_NEW
} from '../actions/Types';

const INITIAL_STATE = {
  tagId: "",
  tagCloudDetail:{},
  projectListing:[],
  propsData: []   

}
export default (state = INITIAL_STATE, action) =>
{    
    switch(action.type)
    {
        case TAG_CLOUD:
            return {...state, tagCloudDetail: action.payload};
        case PROJECT_LISTING:
            return {
                ...state,
                projectListing: [...state.projectListing, ...action.payload]
               }
        case PROJECT_LISTING_NEW:
            return {
                ...state,
                projectListing: action.payload
            }
        case UPDATE_TAG_ID:
            return {...state, tagId: action.payload};
        /*case PROPS_DATA:
            return {...state, propsData: action.payload};*/
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/DashboardReducer.js